import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './NewsDetailModal.css';

// Ensure this helper is also available here for consistent date formatting
const formatFirestoreTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
        return timestamp.toDate().toLocaleDateString('en-GB');
    }
    try {
        const date = new Date(timestamp);
        if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('en-GB');
        }
    } catch (e) {
        // console.error("Error parsing timestamp in NewsDetailModal:", timestamp, e);
    }
    return 'Invalid Date';
};


const NewsDetailModal = ({ newsItem, onClose, onToggleBlockAuthor }) => { // Added onBlockAuthor prop
    if (!newsItem) return null;

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
    };

    // Extract authorDetails from newsItem
    const authorDetails = newsItem.authorDetails || {};
    const authorId = authorDetails.id || 'N/A';
    const isAuthorBlocked = authorDetails.isBlocked || false; // Ensure it's a boolean

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-button" onClick={onClose}>&times;</button>
                <h2>{newsItem.title || 'No Title'}</h2>

                <div className="modal-image-section">
                    {/* 1. Check for Video First */}
                    {newsItem.videoUrl ? (
                        <div className="modal-video-container">
                            <video 
                                src={newsItem.videoUrl} 
                                controls 
                                className="modal-news-video" 
                                playsInline
                                style={{ width: '100%', maxHeight: '400px', borderRadius: '8px' }}
                            />
                        </div>
                    ) : (
                        /* 2. Fallback to Images if no Video */
                        <>
                            {newsItem.imageUrls && newsItem.imageUrls.length > 1 ? (
                                <Slider {...sliderSettings}>
                                    {newsItem.imageUrls.map((url, index) => (
                                        <div key={index}>
                                            <img src={url} alt={`${newsItem.title} - ${index}`} className="modal-news-image" />
                                        </div>
                                    ))}
                                </Slider>
                            ) : newsItem.imageUrls && newsItem.imageUrls.length === 1 ? (
                                <div className="single-image-container">
                                     <img src={newsItem.imageUrls[0]} alt={newsItem.title} className="modal-news-image" />
                                </div>
                            ) : (
                                <p className="no-image-placeholder">No media available.</p>
                            )}
                        </>
                    )}
                </div>

                <div className="modal-text-content">
                    {/* Media Type Badge (Optional but helpful for Admins) */}
                    {newsItem.videoUrl && (
                        <span className="media-type-badge video">Video Post</span>
                    )}

                    {newsItem.description && (
                        <>
                            <h3>Description</h3>
                            <p>{newsItem.description}</p>
                        </>
                    )}
                    {newsItem.content && (
                        <>
                            <h3>Full Content</h3>
                            <p>{newsItem.content}</p>
                        </>
                    )}
                    {!newsItem.description && !newsItem.content && (
                        <p>No description or content available for this post.</p>
                    )}

                    <div className="modal-author-info-section">
                        <h3>Author Information</h3>
                        <p><strong>Author ID:</strong> {authorId}</p>
                        <p><strong>Name:</strong> {authorDetails.name || 'N/A'}</p>
                        <p><strong>Email:</strong> {authorDetails.email || 'N/A'}</p>
                        <p><strong>Mobile:</strong> {authorDetails.phoneNumber || 'N/A'}</p>
                        <p><strong>Status:</strong> {authorDetails.isBlocked ? <span className="status-blocked">Blocked</span> : <span className="status-active">Active</span>}</p>
                        {authorDetails.createdAt && (
                            <p><strong>Joined:</strong> {new Date(authorDetails.createdAt.seconds * 1000).toLocaleDateString()}</p>
                        )}
                        {/* Add more author-specific details as needed */}
                        <div className="modal-actions author-actions"> {/* Added a div for buttons */}
                            {onToggleBlockAuthor && ( // Ensure the prop is passed before rendering
                                <button
                                    onClick={() => onToggleBlockAuthor(authorId, !isAuthorBlocked)} // Pass authorId and the new blocked status
                                    className={`btn-toggle-block-author ${isAuthorBlocked ? 'btn-unblock' : 'btn-block-author'}`}
                                    disabled={!authorId || authorId === 'N/A' || authorId === 'unknown_author'}
                                >
                                    {isAuthorBlocked ? 'Unblock Author' : 'Block Author'}
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="modal-post-meta">
                        <p><strong>Report ID:</strong> {newsItem.reportId || 'N/A'}</p>
                        <p><strong>Posted On:</strong> {newsItem.createdAt ? new Date(newsItem.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}</p>
                        {/* Add other post metadata as needed */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsDetailModal;